// extracted by mini-css-extract-plugin
export default {"image":"I0-z","loaded":"J0-z"};